export default {
  emptyNotice: '暫無內容',
}
